export enum TransactionStatus {
  Pending = 1,
  Canceled = 2,
  Processing = 3,
  Rejected = 4,
  Complete = 5,
  Reversed = 6,
}
